import "./Columns.css";

import React, { useState } from "react";
import {
  selectColumns,
  selectColumnsHasMore,
} from "../../redux/reducers/columnReducer";

import LoginSignUpPopup from "../../components/LoginSignUpPopup/LoginSignUpPopup";
import { NavLink } from "react-router-dom";
import {
  epochToDateStringWithYear,
  getAuthorImage,
  getAuthorName,
} from "../../helper";
import { selectUser } from "../../redux/reducers/userReducer";
import { useColumns } from "../../hooks/APIs/useColumns";
import { usePagination } from "../../hooks/usePagination";
import { useSelector } from "react-redux";

function Columns() {
  const user = useSelector(selectUser);
  const isLoggedIn = Boolean(user?.data?.user?.user_id);
  const stories = useSelector(selectColumns);
  const hasMore = useSelector(selectColumnsHasMore);
  const { fetchColumnData, isLoading } = useColumns();
  usePagination(hasMore, fetchColumnData);

  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  const handleLoginClick = (showType: "login" | "register") => {
    setShowRegister(showType === "register");
    setShowLogin(true);
  };

  const handleCloseModal = () => {
    setShowLogin(false);
  };

  return (
    <div className="columns-page">
      <div className="main-div-column">
        <div className="column-heading">
          {false && (
            <div className="filter-menu">
              <img
                src="./assets/filterMenu.png"
                alt="filter-icon"
                className="filter-img"
              />
              <span className="clm-filter">filter by date</span>
            </div>
          )}
        </div>

        <div className="columnsView">
          {isLoading &&
            Array.from({ length: 5 }, (_, i) => (
              <div key={`skeleton-${i}`} className="news-item-col skeleton-card" aria-hidden="true">
                <div className="news-content-col skeleton-card__content">
                  <div className="date-icon">
                    <span className="skeleton skeleton-text skeleton-col-date" />
                  </div>
                  <div className="heading">
                    <span className="skeleton skeleton-text skeleton-col-heading" />
                  </div>
                  <div className="author-name">
                    <span className="skeleton skeleton-text skeleton-col-author" />
                  </div>
                  <div className="columns-story-media-row">
                    <span className="skeleton skeleton-col-img" />
                    <div className="description">
                      <span className="skeleton skeleton-text skeleton-col-desc" />
                      <span className="skeleton skeleton-text skeleton-col-desc-short" />
                    </div>
                  </div>
                  <span className="skeleton skeleton-text skeleton-col-line" />
                  <span className="skeleton skeleton-text skeleton-col-line" />
                  <span className="skeleton skeleton-text skeleton-col-line-short" />
                </div>
              </div>
            ))}
          {stories.map((story, index) => {
            const imageURL = getAuthorImage(story) ?? story.imageUrl;
            // The list API sends a truncated `teaser` for the first items
            // (full content is no longer shipped in lists — the detail page
            // fetches it by id); `content` kept as fallback for old caches.
            const content = story?.teaser || story?.content || "";
            const showTrialTeaser = !isLoggedIn && index < 4;
            const halfStoryLength = Math.floor(content.length / 4);
            const halfStory = content.slice(0, halfStoryLength);
            const restHalf = content.slice(halfStoryLength);

            return (
              <div key={story.id} className="news-item-col">
                <div className="news-content-col">
                  <div className="date-icon">
                    <div className="time">
                      {epochToDateStringWithYear(story.createdAt._seconds)}
                    </div>
                  </div>
                  {showTrialTeaser ? (
                    <div className="title">
                      <span className="title-heading">{story.heading}</span>
                    </div>
                  ) : (
                    <div className="heading">
                      <NavLink to={`/Details/${story.id}`} className="heading">
                        {story.heading}
                      </NavLink>
                    </div>
                  )}
                  <div className="author-name">By {getAuthorName(story)}</div>
                  <div className="columns-story-media-row">
                    {!!imageURL && (
                      <img
                        src={imageURL}
                        alt={story.heading}
                        className="news-img"
                      />
                    )}
                    <div className="description">{story.subHeading}</div>
                  </div>
                  {showTrialTeaser ? (
                    <div className="trial-story-description">
                      <span
                        className="visible-text"
                        dangerouslySetInnerHTML={{ __html: halfStory }}
                      />
                      <div className="blurred-section">
                        <span
                          className="blurred-text"
                          dangerouslySetInnerHTML={{ __html: restHalf }}
                        />
                        <div className="locked-content">
                          <img
                            src="./assets/Lock.png"
                            alt=""
                            className="locked-img"
                          />
                          <span className="found-interesting">
                            Found this story interesting?
                          </span>
                          <br />
                          <span className="found-interesting-detail">
                            Read the full story and more by starting a free
                            trial.
                          </span>
                          <div className="button-group">
                            <div>
                              <button
                                type="button"
                                className="free-trial-button"
                                onClick={() => handleLoginClick("register")}
                              >
                                Start Free Trial
                              </button>
                            </div>
                            <button
                              type="button"
                              className="subscriber-login-button"
                              onClick={() => handleLoginClick("login")}
                            >
                              Subscriber Login
                            </button>
                          </div>
                          <span className="subscriber-info">
                            The author made this story available to people
                            Registered as a Subscriber to instantly
                            <br />
                            unlock this story plus other premium Subscriber
                            benefits.
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="story-text"
                      dangerouslySetInnerHTML={{
                        __html: content,
                      }}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {showLogin && (
        <LoginSignUpPopup
          onClose={handleCloseModal}
          showRegister={showRegister}
        />
      )}
    </div>
  );
}

export default Columns;
